import { useNavigate } from "react-router-dom";
import styles from "./NotFound404.module.css";

const NotFound404 = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.error}>404</h1>
        <h2 className={styles.subtitle}>Page Not Found</h2>
        <p className={styles.text}>
          Sorry, the page you are looking for might have been removed or is
          temporarily unavailable.
        </p>
        <button className={styles.button} onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound404;
